"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_types_1 = require("pages/app.types");
const toolkit_1 = require("@reduxjs/toolkit");
const production_types_1 = require("./production.types");
const initialState = {
    dataGrid: [],
    errorCode: 0,
    isError: false,
    errorMessage: '',
    isLoading: false,
    isSuccess: false,
    mutationMode: false,
    dataGridHistory: [],
    isLoadingUpload: false,
    isLoadingDownload: false,
    selectedYear: new Date().getFullYear().toString(),
    lastUpdated: new Date(),
    dataItem: {
        id: '',
        jan: 0,
        feb: 0,
        mar: 0,
        apr: 0,
        may: 0,
        jun: 0,
        jul: 0,
        aug: 0,
        sep: 0,
        oct: 0,
        nov: 0,
        dec: 0,
        area: '',
        brand: '',
        year: '',
        contractor: '',
        created_by: '',
        modified_by: '',
        created_date: new Date(),
        modified_date: new Date(),
    },
    dataItemHistory: {
        id: '',
        year: '',
        status: '',
        filename: '',
        filepath: '',
        log_message: '',
        uploaded_by: '',
        uploaded_at: new Date(),
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 1000,
        total: 0,
        sort: [
            { field: 'contractor', dir: 'asc' },
            { field: 'brand', dir: 'asc' },
            { field: 'area', dir: 'asc' },
        ]
    },
    dataStatesHistory: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'uploaded_at', dir: 'desc' }]
    },
};
const planningProductionReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [production_types_1.planningProductionTypes.SET_DATA_GRID_PRODUCTION]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [production_types_1.planningProductionTypes.SET_DATA_GRID_HISTORY]: (state, action) => {
        const { count, dataGridHistory } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGridHistory, isLoading: false, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { total: count }) });
    },
    [production_types_1.planningProductionTypes.SET_LAST_SUCCEED_UPLOAD]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: false, lastUpdated: action.payload.lastUpdated });
    },
    [production_types_1.planningProductionTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [production_types_1.planningProductionTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, dataItemHistory, mutationMode, selectedYear, isSuccess, isLoadingUpload, isLoadingDownload, } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, selectedYear: selectedYear ? selectedYear : initialState.selectedYear, dataItemHistory: dataItemHistory ? dataItemHistory : initialState.dataItemHistory, isLoadingUpload: isLoadingUpload ? isLoadingUpload : initialState.isLoadingUpload, isLoadingDownload: isLoadingDownload ? isLoadingDownload : initialState.isLoadingDownload });
    },
    [production_types_1.planningProductionTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [production_types_1.planningProductionTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false, isSuccess: false, isLoadingUpload: false, isLoadingDownload: false });
    },
    [production_types_1.planningProductionTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload }) });
    },
    [production_types_1.planningProductionTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [production_types_1.planningProductionTypes.ON_PAGE_CHANGE_HISTORY]: (state, action) => {
        const { dataStatesHistory } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStatesHistory, isLoading: true });
    },
    [production_types_1.planningProductionTypes.ON_FILTER_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { isLoading: true, filter: action.payload }) });
    },
    [production_types_1.planningProductionTypes.ON_SORT_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { isLoading: true, sort: action.payload }) });
    }
});
exports.default = planningProductionReducer;
